import React, { useContext } from 'react';

import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import Tappable from 'common/Tappable';
import styles from 'css-module/components/www/_PricingV4.module.scss';

export default function PricingV4Discounts() {
  const showIntercom = useContext(ShowIntercomContext);
  const onContactUsTapped = () => {
    showIntercom();
  };

  return (
    <div className={styles.pricingV4Discounts}>
      <div className={styles.discounts}>
        <div className={styles.discountsText}>
          <div className={styles.discountsTitle}>Yearly plan discounts</div>
          <div className={styles.discountsDescription}>
            Save up to 20% by paying for a year&nbsp;upfront.
          </div>
          <div className={styles.discountsSpacer} />
          <a className={styles.discountsCTA} href="https://canny.io/register" rel="noopener">
            Get started
          </a>
        </div>
      </div>
      <div className={styles.discounts}>
        <div className={styles.discountsText}>
          <div className={styles.discountsTitle}>Plans for B2C</div>
          <div className={styles.discountsDescription}>
            We offer special plans for high-volume consumer-facing&nbsp;products.
          </div>
          <div className={styles.discountsSpacer} />
          <Tappable onTap={onContactUsTapped}>
            <div className={styles.discountsCTA}>Contact us to see if you qualify</div>
          </Tappable>
        </div>
      </div>
      <div className={styles.discounts}>
        <div className={styles.discountsText}>
          <div className={styles.discountsTitle}>Discounts for&nbsp;non&#8209;profits</div>
          <div className={styles.discountsDescription}>
            We offer discounts for qualified non&#8209;profits.
          </div>
          <div className={styles.discountsSpacer} />
          <Tappable onTap={onContactUsTapped}>
            <div className={styles.discountsCTA}>Contact us to see if you qualify</div>
          </Tappable>
        </div>
      </div>
    </div>
  );
}
